import { defineComponent as _defineComponent } from 'vue'
import moment from "moment"
import { computed } from "vue"

import i18n from "@/i18n"

type Props = {
  date: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRenderer',
  props: {
    date: null
  },
  setup(__props: any) {

const props = __props as {
  date: string | null
};



const formatOrderedAtDate = computed(() => {
  if (!props.date) {
    return ""
  }

  const orderedAt = moment(props.date)
  const isCurrentDate = orderedAt.isSame(new Date(), "day")

  return isCurrentDate ? i18n.t("orders.today") : orderedAt.format("DD.MM.YYYY")
})
const formatOrderedAtTime = computed(() => {
  if (!props.date) {
    return ""
  }

  return moment(props.date).format("HH:mm")
})

return { __sfc: true,props, formatOrderedAtDate, formatOrderedAtTime }
}

})